/**
 * Created by Asma on 27/11/2016.
 */

function initializeBanner(){

  /*  var $bannerSlides = jQuery('.banner-slides');

    $bannerSlides.slick({

        autoplay : true,
        autoplaySpeed : 4000,
        dots : true,
        fade : true,
        infinite : true,
        swipe : false,
        useCSS : true
    });
    $bannerSlides.show();*/

}
function initializeCarousel() {
  /*  var $carouselSlides = jQuery('.carousel-slides');

    if (jQuery(window).width() > 420) {
        jQuery('.carousel-slides').unslick();
        jQuery('.carousel-slides').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            dots: true,
        });

    }*/

}
/*
jQuery(document).on('click','.deco-text',function show(){
    $(".deco").css("display", "block");
});
*/

/*var theToggle = document.getElementById('toggle');

// based on Todd Motto functions
// http://toddmotto.com/labs/reusable-js/

// hasClass
function hasClass(elem, className) {
    return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
}
// addClass
function addClass(elem, className) {
    if (!hasClass(elem, className)) {
        elem.className += ' ' + className;
    }
}
// removeClass
function removeClass(elem, className) {
    var newClass = ' ' + elem.className.replace( /[\t\r\n]/g, ' ') + ' ';
    if (hasClass(elem, className)) {
        while (newClass.indexOf(' ' + className + ' ') >= 0 ) {
            newClass = newClass.replace(' ' + className + ' ', ' ');
        }
        elem.className = newClass.replace(/^\s+|\s+$/g, '');
    }
}
// toggleClass
function toggleClass(elem, className) {
    var newClass = ' ' + elem.className.replace( /[\t\r\n]/g, " " ) + ' ';
    if (hasClass(elem, className)) {
        while (newClass.indexOf(" " + className + " ") >= 0 ) {
            newClass = newClass.replace( " " + className + " " , " " );
        }
        elem.className = newClass.replace(/^\s+|\s+$/g, '');
    } else {
        elem.className += ' ' + className;
    }
}

theToggle.onclick = function() {
    toggleClass(this, 'on');
    return false;
}*/
function selecteurDate() {





        //console.log(eventsArray);
        //var arr = jQuery.parseJSON(eventsArray);
        /*for(i = 0; i < jQuery("eventsArray").length; i++) {
         console.log(event.title, event.start._d, event.end._d);
         if (event.title=='test'){
         jQuery('.fc-day').each(function () {
         var currentDate=new Date(jQuery(this).attr('data-date'));
         if (event.start._d == currentDate ){
         jQuery(this).css('background-color', 'green');
         console.log('match');

         }
         });
         }
         }*/


        jQuery('.fc-button').on('click',function () {
            jQuery ('.fc-past').each(function () {
                jQuery(this).css('background-color', '#fff');
            });
            jQuery ('.fc-other-month').each(function () {
                jQuery(this).css('background-color', '#fff');
            });
            jQuery('.fc-day').each(function () {
                var currentDateForum=new Date(jQuery(this).attr('data-date'));
                //console.log(currentDateForum.getMonth());


                if (currentDateForum.getDay() == 6) {
                    jQuery(this).css('background-color', '#dd1032');

                }

                //conditions Azur


                if ((((currentDateForum.getMonth() == 0) || (currentDateForum.getMonth() == 1) || (currentDateForum.getMonth() == 3) || (currentDateForum.getMonth() == 4) || (currentDateForum.getMonth() == 9) || (currentDateForum.getMonth() == 10)) || (((currentDateForum.getMonth() == 2) || (currentDateForum.getMonth() == 11)) && ((currentDateForum.getDate() > 0) && ((currentDateForum.getDate() < 14))))) && ((currentDateForum.getDay() == 1) || (currentDateForum.getDay() == 2) || (currentDateForum.getDay() == 3))) {

                    jQuery(this).css('background-color', '#0099d7');

                    //jQuery(this).css('border-color', '#0099d7'); // colors first day of the week blue

                }
                //jQuery('.fc-event-container')


                //conditions Orange

                if ((((currentDateForum.getMonth() == 0) || (currentDateForum.getMonth() == 1) || (currentDateForum.getMonth()== 3) || (currentDateForum.getMonth() == 4) || (currentDateForum.getMonth() == 9) || (currentDateForum.getMonth() == 10)) || (((currentDateForum.getMonth() == 2) || (currentDateForum.getMonth() == 11)) && ((currentDateForum.getDate() > 0) && ((currentDateForum.getDate() < 14))))) && ((currentDateForum.getDay()  == 4) || (currentDateForum.getDay()  == 5) || (currentDateForum.getDay()  == 0))) {

                    jQuery(this).css('background-color', '#ff8600');

                    // jQuery(this).css('border-color', '#ff8600'); // colors first day of the week blue

                }
            });


        });


        var eventForum=[];
        jQuery ('.fc-past').each(function () {
            jQuery(this).css('background-color', '#fff');
        });
        jQuery ('.fc-other-month').each(function () {
            jQuery(this).css('background-color', '#fff');
        });
        jQuery('.fc-day').each(function () {
            var currentDateForum=new Date(jQuery(this).attr('data-date'));
            //console.log(currentDateForum.getDate());
            var eventsArray=jQuery('#eo_fullcalendar_1').fullCalendar( 'clientEvents');
            jQuery.each(eventsArray, function(key,value) {
                //var currentDate=new Date(jQuery(this).attr('data-date'));
                //console.log(currentDateForum);

                console.log(eventForum);

                if(eventForum.indexOf(value)==-1){
                    eventForum.push(value) ;
                    console.log('event pushed' );
                    console.log(eventForum);
                    if(value.category[0]=="ramadan"){
                        console.log(value.title,"ramadan");
                    }
                    else if(value.category[0]=="jour-ferie"){
                        console.log(JSON.stringify(value));
                        var start=new Date(value.start, 'dd/mm/yyyy');
                        //var start = dateFormat(new Date( value.start), 'dd/mm/yyyy');

                        //var start = formatDate( value.start, "dd/MM/yyyy");

                        console.log(start);


                        var end= new Date (value.end);
                        console.log(start);
                        console.log(end);
                        var eventDays=[];
                        while (start != end){
                            eventDays.push(start);
                            start.setDate(start.getDate()+1);
                        }
                        console.log('férié');
                        console.log(eventDays);
                    }
                    else if(value.category[0]=="vacance-scolaire"){
                        console.log(value.title,"vacance-scolaire");
                    }
                }




            });

            if (currentDateForum.getDay() == 6) {
                jQuery(this).css('background-color', '#dd1032');

            }

            //conditions Azur


            if ((((currentDateForum.getMonth() == 0) || (currentDateForum.getMonth() == 1) || (currentDateForum.getMonth() == 3) || (currentDateForum.getMonth() == 4) || (currentDateForum.getMonth() == 9) || (currentDateForum.getMonth() == 10)) || (((currentDateForum.getMonth() == 2) || (currentDateForum.getMonth() == 11)) && ((currentDateForum.getDate() > 0) && ((currentDateForum.getDate() < 14))))) && ((currentDateForum.getDay() == 1) || (currentDateForum.getDay() == 2) || (currentDateForum.getDay() == 3))) {

                jQuery(this).css('background-color', '#0099d7');

                // jQuery(this).css('border-color', '#0099d7'); // colors first day of the week blue

            }


            //conditions Orange

            if ((((currentDateForum.getMonth() == 0) || (currentDateForum.getMonth() == 1) || (currentDateForum.getMonth()== 3) || (currentDateForum.getMonth() == 4) || (currentDateForum.getMonth() == 9) || (currentDateForum.getMonth() == 10)) || (((currentDateForum.getMonth() == 2) || (currentDateForum.getMonth() == 11)) && ((currentDateForum.getDate() > 0) && ((currentDateForum.getDate() < 14))))) && ((currentDateForum.getDay()  == 4) || (currentDateForum.getDay()  == 5) || (currentDateForum.getDay()  == 0))) {

                jQuery(this).css('background-color', '#ff8600');

                //jQuery(this).css('border-color', '#ff8600'); // colors first day of the week blue

            }

        });

       jQuery( document ).tooltip();


}
